import type { AudioLevelProbe } from "../audio-level-probe";

export class WebAnalyserProbe implements AudioLevelProbe {
  private readonly analyser: AnalyserNode;

  constructor(analyser: AnalyserNode, { fftSize = 64, smoothingTimeConstant = 0.8 } = {}) {
    this.analyser = analyser;
    this.analyser.fftSize = fftSize;
    this.analyser.smoothingTimeConstant = smoothingTimeConstant;
  }

  get fftSize(): number {
    return this.analyser.fftSize;
  }

  getByteTimeDomainData(target: Uint8Array): void {
    this.analyser.getByteTimeDomainData(target);
  }

  dispose(): void {
    // no-op: lifecycle handled by audio capture teardown
  }
}
